import React from 'react';

const Body = ({ className = '', children }) => (
  <div className={`table-body ${className}`}>{children}</div>
);

const Row = ({ className = '', children }) => (
  <div className={`t-row ${className}`}>{children}</div>
);

const Left = ({ className = '', children }) => (
  <div className={`t-row--left ${className}`}>{children}</div>
);

const Right = ({ className = '', children }) => (
  <div className={`t-row--right ${className}`}>{children}</div>
);

const Element = ({ className = '', children }) => (
  <div className={`t-element ${className}`}>{children}</div>
);

export default {
  Body,
  Row,
  Left,
  Right,
  Element,
};


// WEBPACK FOOTER //
// ./src/components/ui/Table.jsx